import dayjs from "dayjs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { actions as paymentActions } from 'features/payment';

import { paymentHistoryConverter } from "./paymentHistoryConverter";

const itemsOnPage = 10;

const usePaymentHistory = () => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    isSuccess: true,
    isTimeIsUp: true,
    dateFrom: dayjs().add(-7, 'day').startOf('day').toDate(),
    dateTo: dayjs().endOf('day').toDate(),
    page: 0,
    itemsOnPage,
  });

  useEffect(() => {
    const requestData = paymentHistoryConverter(values, itemsOnPage);
    dispatch(paymentActions.getDepositHistory(requestData))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.page, dispatch]);

  const onIsSuccessChange = useCallback(() => {
    setValues(ps => ({ ...ps, isSuccess: !ps.isSuccess }));
  }, []);

  const onIsTimeIsUpChange = useCallback(() => {
    setValues(ps => ({ ...ps, isTimeIsUp: !ps.isTimeIsUp }));
  }, []);

  const onDateFromChange = useCallback(value => {
    setValues(ps => ({ ...ps, dateFrom: value }));
  }, []);

  const onDateToChange = useCallback(value => {
    setValues(ps => ({ ...ps, dateTo: value }));
  }, []);

  const onPageChange = useCallback(value => {
    setValues(ps => ({ ...ps, page: value }));
  }, []);

  const onSubmit = useCallback(e => {
    e.preventDefault();
    const requestData = paymentHistoryConverter({ ...values, page: 0 }, itemsOnPage);
    dispatch(paymentActions.getDepositHistory(requestData))
  }, [values, dispatch]);

  return useMemo(() => ({
    onIsSuccessChange,
    onIsTimeIsUpChange,
    onDateFromChange,
    onDateToChange,
    onPageChange,
    onSubmit,
    values,
  }), [
    onIsSuccessChange,
    onIsTimeIsUpChange,
    onDateFromChange,
    onDateToChange,
    onPageChange,
    onSubmit,
    values,
  ]);
};

export default usePaymentHistory;
